import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/4_card_back_red_pattern/4_card_back_red_pattern"
 * Contains 1 texture(s)
 */
export class CardsBacks4CardBackRedPatternAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/4_card_back_red_pattern/4_card_back_red_pattern';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '4_red_pattern.png'
    ] as const;
}
